import React from "react";
import {
  AUTH_PREFIX_PATH,
  APP_PREFIX_PATH,
  PUBLIC_PREFIX_PATH,
} from "configs/AppConfig";

export const authRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
    access: [],
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password"),
    ),
    access: [],
  },
  {
    key: "resend-email",
    path: `${AUTH_PREFIX_PATH}/success-send-email`,
    component: React.lazy(
      () => import("views/auth-views/authentication/resend-email/forgot"),
    ),
    access: [],
  },
  {
    key: "reset-password",
    path: `${AUTH_PREFIX_PATH}/reset-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/reset-password"),
    ),
    access: [],
  },
  {
    key: "change-password",
    path: `${AUTH_PREFIX_PATH}/change-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/change-password"),
    ),
    access: [],
  },
  {
    key: "download-app",
    path: `${AUTH_PREFIX_PATH}/download`,
    component: React.lazy(() => import("views/public-views/app-download")),
    meta: {
      blankLayout: true,
    },
    access: [],
  },
  {
    key: "error",
    path: `*`,
    component: React.lazy(() => import("views/auth-views/errors/404")),
    meta: {
      blankLayout: true,
    },
    access: [],
  },
];

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
    access: [],
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password"),
    ),
    access: [],
  },
  {
    key: "resend-email",
    path: `${AUTH_PREFIX_PATH}/success-send-email`,
    component: React.lazy(
      () => import("views/auth-views/authentication/resend-email/forgot"),
    ),
    access: [],
  },
  {
    key: "reset-password",
    path: `${AUTH_PREFIX_PATH}/reset-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/reset-password"),
    ),
    access: [],
  },
  {
    key: "change-password",
    path: `${AUTH_PREFIX_PATH}/change-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/change-password"),
    ),
    access: [],
  },
  {
    key: "download-app-public",
    path: `${PUBLIC_PREFIX_PATH}/download-app`,
    component: React.lazy(() => import("views/public-views/app-download")),
    meta: {
      blankLayout: true,
    },
    access: [],
  },
  {
    key: "error",
    path: `*`,
    component: React.lazy(() => import("views/auth-views/errors/404")),
    meta: {
      blankLayout: true,
    },
    access: [],
  },
];

export const protectedRoutes = [
  {
    key: "dashboard",
    path: `${APP_PREFIX_PATH}`,
    component: React.lazy(() => import("views/app-views/onboarding")),
    access: [],
  },

  // Tarif Umum
  {
    key: "tarif-umum",
    path: `${APP_PREFIX_PATH}/tarif-umum`,
    component: React.lazy(
      () => import("views/app-views/commercial/tarif-umum"),
    ),
    access: ["01.07.00"],
  },
  {
    key: "tarif-umum-form",
    path: `${APP_PREFIX_PATH}/tarif-umum/form`,
    component: React.lazy(
      () => import("views/app-views/commercial/tarif-umum/form"),
    ),
    access: ["01.07.01", "01.07.02"],
  },

  // Data Pembayar
  {
    key: "pembayar-data",
    path: `${APP_PREFIX_PATH}/commercial/pembayar`,
    component: React.lazy(
      () => import("views/app-views/commercial/pembayar/data"),
    ),
    access: ["01.00.00"],
  },
  {
    key: "pembayar-form",
    path: `${APP_PREFIX_PATH}/commercial/pembayar/form`,
    component: React.lazy(
      () => import("views/app-views/commercial/pembayar/form"),
    ),
    access: ["01.00.01", "01.00.02"],
  },
  {
    key: "pembayar-detail",
    path: `${APP_PREFIX_PATH}/commercial/pembayar/detail`,
    component: React.lazy(
      () => import("views/app-views/commercial/pembayar/detail"),
    ),
    access: [
      "01.00.04.00",
      "01.00.04.05.00",
      "01.00.04.06.00",
      "01.00.04.07.00",
      "01.00.04.08.00",
    ],
  },
  {
    key: "pembayar-customer-service-form",
    path: `${APP_PREFIX_PATH}/commercial/pembayar/customer-service/form`,
    component: React.lazy(
      () =>
        import("views/app-views/commercial/pembayar/detail/customer-service/form"),
    ),
    access: ["01.00.04.05.01", "01.00.04.05.02"],
  },
  {
    key: "pembayar-customer-ar-form",
    path: `${APP_PREFIX_PATH}/commercial/pembayar/customer-ar/form`,
    component: React.lazy(
      () =>
        import("views/app-views/commercial/pembayar/detail/customer-ar/form"),
    ),
    access: ["01.00.04.06.01", "01.00.04.06.02"],
  },
  {
    key: "pembayar-customer-bank-form",
    path: `${APP_PREFIX_PATH}/commercial/pembayar/customer-bank/form`,
    component: React.lazy(
      () =>
        import("views/app-views/commercial/pembayar/detail/customer-bank/form"),
    ),
    access: ["01.00.04.07.01", "01.00.04.07.01"],
  },

  // Tarif Pembayar
  {
    key: "tarif-pembayar-form",
    path: `${APP_PREFIX_PATH}/commercial/pembayar/pricelist/form`,
    component: React.lazy(
      () => import("views/app-views/commercial/pembayar/detail/tarif/form"),
    ),
    access: [],
  },
  {
    key: "tarif-pembayar-detail",
    path: `${APP_PREFIX_PATH}/commercial/pembayar/pricelist/detail`,
    component: React.lazy(
      () => import("views/app-views/commercial/pembayar/detail/tarif/detail"),
    ),
    access: ["01.00.04.08.01", "01.00.04.08.02"],
  },

  // Pengirim/Penerima
  {
    key: "pengirim-penerima-data",
    path: `${APP_PREFIX_PATH}/commercial/pengirim-penerima`,
    component: React.lazy(
      () => import("views/app-views/commercial/pengirim-penerima/data"),
    ),
    access: ["01.01.00"],
  },
  {
    key: "pengirim-penerima-detail",
    path: `${APP_PREFIX_PATH}/commercial/pengirim-penerima/detail`,
    component: React.lazy(
      () => import("views/app-views/commercial/pengirim-penerima/detail"),
    ),
    access: ["01.01.04.00"],
  },
  {
    key: "pengirim-penerima-form",
    path: `${APP_PREFIX_PATH}/commercial/pengirim-penerima/form`,
    component: React.lazy(
      () => import("views/app-views/commercial/pengirim-penerima/form"),
    ),
    access: ["01.01.01", "01.01.02"],
  },
  {
    key: "component-address-form",
    path: `${APP_PREFIX_PATH}/commercial/pengirim-penerima/alamat/form`,
    component: React.lazy(
      () => import("views/app-views/commercial/pengirim-penerima/address/form"),
    ),
    access: ["01.01.04.01", "01.01.04.02"],
  },

  // Booking Order
  {
    key: "booking-data",
    path: `${APP_PREFIX_PATH}/commercial/booking-order`,
    component: React.lazy(
      () => import("views/app-views/commercial/booking/data"),
    ),
    access: ["01.02.00"],
  },

  // Pickup Order
  {
    key: "pickup-data",
    path: `${APP_PREFIX_PATH}/commercial/pickup-order`,
    component: React.lazy(
      () => import("views/app-views/commercial/pickup/data"),
    ),
    access: ["01.03.00"],
  },
  {
    key: "pickup-detail",
    path: `${APP_PREFIX_PATH}/commercial/pickup-order/detail`,
    component: React.lazy(
      () => import("views/app-views/commercial/pickup/detail"),
    ),
    access: ["01.03.04.00"],
  },
  {
    key: "pickup-form",
    path: `${APP_PREFIX_PATH}/commercial/pickup-order/form`,
    component: React.lazy(
      () => import("views/app-views/commercial/pickup/form"),
    ),
    access: ["01.03.01", "01.03.02"],
  },
  {
    key: "pickup-print-pio",
    path: `${APP_PREFIX_PATH}/commercial/pickup-order/print/pio`,
    component: React.lazy(
      () => import("views/app-views/commercial/pickup/print/pio"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["01.03.04.02"],
  },
  {
    key: "pickup-print-preview",
    path: `${APP_PREFIX_PATH}/commercial/pickup-order/print/preview`,
    component: React.lazy(
      () => import("views/app-views/commercial/pickup/print/preview"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["01.03.04.03"],
  },
  {
    key: "pickup-print-preview",
    path: `${APP_PREFIX_PATH}/commercial/pickup-order/print/sjp`,
    component: React.lazy(
      () => import("views/app-views/commercial/pickup/print/sjp"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["01.03.04.04"],
  },

  // Komisi CS/SM
  {
    key: "staff-commission",
    path: `${APP_PREFIX_PATH}/commercial/commission`,
    component: React.lazy(
      () => import("views/app-views/commercial/commission"),
    ),
    access: ["01.06.00", "01.06.01"],
  },

  // Quotation Log
  {
    key: "quotation-log-form",
    path: `${APP_PREFIX_PATH}/commercial/quotation-log/form`,
    component: React.lazy(
      () => import("views/app-views/commercial/quotation-log/form"),
    ),
    access: ["01.08.00", "01.08.01", "01.08.02"],
  },
  {
    key: "quotation-log-detail",
    path: `${APP_PREFIX_PATH}/commercial/quotation-log/detail`,
    component: React.lazy(
      () => import("views/app-views/commercial/quotation-log/detail"),
    ),
    access: ["01.08.00"],
  },
  {
    key: "quotation-log-print-print",
    path: `${APP_PREFIX_PATH}/commercial/quotation-log/print`,
    component: React.lazy(
      () => import("views/app-views/commercial/quotation-log/print/preview"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["01.08.00"],
  },
  {
    key: "quotation-log-setting",
    path: `${APP_PREFIX_PATH}/commercial/quotation-log/setting`,
    component: React.lazy(
      () => import("views/app-views/commercial/quotation-log/setting"),
    ),
    access: ["00.12.00", "00.12.01"],
  },
  {
    key: "quotation-log-data",
    path: `${APP_PREFIX_PATH}/commercial/quotation-log`,
    component: React.lazy(
      () => import("views/app-views/commercial/quotation-log/data"),
    ),
    access: ["01.08.00"],
  },

  // Invoice Jual
  {
    key: "sales-invoice",
    path: `${APP_PREFIX_PATH}/invoices`,
    component: React.lazy(() => import("views/app-views/invoice/data")),
    access: ["01.05.00", "04.01.00.00"],
  },
  {
    key: "sales-invoice-detail",
    path: `${APP_PREFIX_PATH}/invoices/detail`,
    component: React.lazy(() => import("views/app-views/invoice/detail")),
    access: ["01.05.04.00", "04.01.00.04.00"],
  },
  {
    key: "sales-invoice-form",
    path: `${APP_PREFIX_PATH}/invoices/form`,
    component: React.lazy(() => import("views/app-views/invoice/form")),
    access: ["01.05.01", "01.05.02", "04.01.00.01", "04.01.00.02"],
  },
  {
    key: "invoice-print",
    path: `${APP_PREFIX_PATH}/invoices/print/invoice`,
    component: React.lazy(
      () => import("views/app-views/invoice/print/invoice"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["01.05.04.10", "04.01.00.04.10"],
  },
  {
    key: "invoice-preview",
    path: `${APP_PREFIX_PATH}/invoices/print/preview`,
    component: React.lazy(
      () => import("views/app-views/invoice/print/preview"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["01.05.04.11", "04.01.00.04.11"],
  },

  // Pengantar Invoice
  {
    key: "pengantar-invoice-data",
    path: `${APP_PREFIX_PATH}/account-receivable/pengantar-invoice`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-receivable/pengantar-invoice/data"),
    ),
    access: ["04.01.01.00"],
  },
  {
    key: "pengantar-invoice-detail",
    path: `${APP_PREFIX_PATH}/account-receivable/pengantar-invoice/detail`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-receivable/pengantar-invoice/detail"),
    ),
    access: ["04.01.01.04.00"],
  },
  {
    key: "pengantar-invoice-form",
    path: `${APP_PREFIX_PATH}/account-receivable/pengantar-invoice/form`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-receivable/pengantar-invoice/form"),
    ),
    access: ["04.01.01.01", "04.01.01.02"],
  },
  {
    key: "pengantar-invoice-print",
    path: `${APP_PREFIX_PATH}/account-receivable/pengantar-invoice/print`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-receivable/pengantar-invoice/print"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["04.01.01.04.04"],
  },

  //Info AR
  {
    key: "info-ar-data",
    path: `${APP_PREFIX_PATH}/account-receivable/info-ar`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-receivable/info-ar/data"),
    ),
    access: ["04.01.03.00.00", "04.01.03.01.00", "04.01.03.02.00"],
  },

  //Pelunasan
  {
    key: "pelunasan-data",
    path: `${APP_PREFIX_PATH}/account-receivable/pelunasan`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-receivable/pelunasan/data"),
    ),
    access: ["04.01.02.00"],
  },
  {
    key: "pelunasan-detail",
    path: `${APP_PREFIX_PATH}/account-receivable/pelunasan/detail`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-receivable/pelunasan/detail"),
    ),
    access: ["04.01.02.03.00"],
  },
  {
    key: "pelunasan-form",
    path: `${APP_PREFIX_PATH}/account-receivable/pelunasan/form`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-receivable/pelunasan/form"),
    ),
    access: ["04.01.02.01", "04.01.02.02"],
  },
  {
    key: "pelunasan-detail-form",
    path: `${APP_PREFIX_PATH}/account-receivable/pelunasan/tambah-pelunasan/form`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-receivable/pelunasan/form-tambah-pelunasan"),
    ),
    access: ["04.01.02.01", "04.01.02.02", "04.01.02.03.01"],
  },
  {
    key: "pelunasan-invoice-print",
    path: `${APP_PREFIX_PATH}/account-receivable/pelunasan/print`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-receivable/pelunasan/print"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["04.01.02.03.04"],
  },

  //AP-Jurnal Biaya Akrual
  {
    key: "jurnal-biaya-akrual-data",
    path: `${APP_PREFIX_PATH}/account-payable/jurnal-biaya-akrual`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-payable/jurnal-akrual/data"),
    ),
    access: ["04.02.00.00"],
  },
  {
    key: "pelunasan-detail-form",
    path: `${APP_PREFIX_PATH}/account-payable/jurnal-biaya-akrual/form`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-payable/jurnal-akrual/form"),
    ),
    access: ["04.02.00.03"],
  },

  // Default Akun
  {
    key: "default-account",
    path: `${APP_PREFIX_PATH}/finance/default-account`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/default-account"),
    ),
    access: ["04.00.00", "04.00.01"],
  },

  //AP-Tagihan
  {
    key: "tagihan-data",
    path: `${APP_PREFIX_PATH}/account-payable/tagihan`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-payable/tagihan/data"),
    ),
    access: ["04.02.01.00"],
  },
  {
    key: "tagihan-detail",
    path: `${APP_PREFIX_PATH}/account-payable/tagihan/detail`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-payable/tagihan/detail"),
    ),
    access: ["04.02.01.04.00"],
  },
  {
    key: "tagihan-form",
    path: `${APP_PREFIX_PATH}/account-payable/tagihan/form`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-payable/tagihan/form"),
    ),
    access: ["04.02.01.01", "04.02.01.02"],
  },

  //AP-Pembayaran Tagihan
  {
    key: "pembayaran-tagihan-data",
    path: `${APP_PREFIX_PATH}/account-payable/pembayaran-tagihan`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-payable/pembayaran-tagihan/data"),
    ),
    access: ["04.02.02.00"],
  },
  {
    key: "pembayaran-tagihan-detail",
    path: `${APP_PREFIX_PATH}/account-payable/pembayaran-tagihan/detail`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-payable/pembayaran-tagihan/detail"),
    ),
    access: ["04.02.02.04.00"],
  },
  {
    key: "pembayaran-tagihan-form",
    path: `${APP_PREFIX_PATH}/account-payable/pembayaran-tagihan/form`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-payable/pembayaran-tagihan/form"),
    ),
    access: ["04.02.02.01", "04.02.02.01"],
  },
  {
    key: "pembayaran-tagihan-print",
    path: `${APP_PREFIX_PATH}/account-payable/pembayaran-tagihan/print`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-payable/pembayaran-tagihan/print"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["04.02.02.04.03"],
  },
  //AP-Pencairan Giro
  {
    key: "pencairan-giro-data",
    path: `${APP_PREFIX_PATH}/account-payable/pencairan-giro`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-payable/pencairan-giro/data"),
    ),
  },

  //AP-Info AP
  {
    key: "info-ap-data",
    path: `${APP_PREFIX_PATH}/account-payable/info-ap`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/account-payable/info-ap/data"),
    ),
    access: ["04.02.03.00"],
  },

  //AP-Transaksi Kas
  {
    key: "transaksi-kas-data",
    path: `${APP_PREFIX_PATH}/account-payable/transaksi-kas`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/transaksi/kas/data"),
    ),
    access: ["04.03.00.00"],
  },
  {
    key: "transaksi-kas-detail",
    path: `${APP_PREFIX_PATH}/account-payable/transaksi-kas/detail`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/transaksi/kas/detail"),
    ),
    access: ["04.03.00.04.00"],
  },
  {
    key: "transaksi-kas-form",
    path: `${APP_PREFIX_PATH}/account-payable/transaksi-kas/form`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/transaksi/kas/form"),
    ),
    access: ["04.03.00.01", "04.03.00.02"],
  },
  {
    key: "transaksi-kas-print",
    path: `${APP_PREFIX_PATH}/account-payable/transaksi-kas/print`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/transaksi/kas/print"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["04.03.00.04.04"],
  },

  //Transaksi Bank
  {
    key: "transaksi-bank-data",
    path: `${APP_PREFIX_PATH}/account-payable/transaksi-bank`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/transaksi/bank/data"),
    ),
    access: ["04.03.01.00"],
  },
  {
    key: "transaksi-bank-detail",
    path: `${APP_PREFIX_PATH}/account-payable/transaksi-bank/detail`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/transaksi/bank/detail"),
    ),
    access: ["04.03.01.04.00"],
  },
  {
    key: "transaksi-bank-form",
    path: `${APP_PREFIX_PATH}/account-payable/transaksi-bank/form`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/transaksi/bank/form"),
    ),
    access: ["04.03.01.01", "04.03.01.02"],
  },
  {
    key: "transaksi-bank-print",
    path: `${APP_PREFIX_PATH}/account-payable/transaksi-bank/print`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/transaksi/bank/print"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["04.03.01.04.04"],
  },

  //Jurnal Umum
  {
    key: "jurnal-umum-data",
    path: `${APP_PREFIX_PATH}/account-payable/jurnal-umum`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/transaksi/jurnal-umum/data"),
    ),
    access: ["04.03.02.00"],
  },
  {
    key: "jurnal-umum-detail",
    path: `${APP_PREFIX_PATH}/account-payable/jurnal-umum/detail`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/transaksi/jurnal-umum/detail"),
    ),
    access: ["04.03.02.04.00"],
  },
  {
    key: "jurnal-umum-mass-posting",
    path: `${APP_PREFIX_PATH}/account-payable/jurnal-umum/mass-posting`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/transaksi/jurnal-umum/posting"),
    ),
    access: ["04.03.02.05"],
  },
  {
    key: "jurnal-umum-form",
    path: `${APP_PREFIX_PATH}/account-payable/jurnal-umum/form`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/transaksi/jurnal-umum/form"),
    ),
    access: ["04.03.02.01", "04.03.02.02"],
  },

  //Penggantian Biaya Cabang Tujuan (PBCT)
  {
    key: "pbct-data",
    path: `${APP_PREFIX_PATH}/account-payable/pbct`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/transaksi/pbct/data"),
    ),
    access: ["04.03.03.00"],
  },
  {
    key: "pbct-detail",
    path: `${APP_PREFIX_PATH}/account-payable/pbct/detail`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/transaksi/pbct/detail"),
    ),
    access: ["04.03.03.04.00"],
  },
  {
    key: "pbct-form",
    path: `${APP_PREFIX_PATH}/account-payable/pbct/form`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/transaksi/pbct/form"),
    ),
    access: ["04.03.03.01", "04.03.03.02"],
  },
  {
    key: "pbct-print",
    path: `${APP_PREFIX_PATH}/account-payable/pbct/print`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/transaksi/pbct/print"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["04.03.03.04.03"],
  },

  // FINANCE REPORT
  {
    key: "finance-buku-besar",
    path: `${APP_PREFIX_PATH}/finance/buku-besar`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/report/buku-besar"),
    ),
    access: ["04.04.00.00"],
  },
  {
    key: "finance-neraca-saldo",
    path: `${APP_PREFIX_PATH}/finance/neraca-saldo`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/report/neraca-saldo"),
    ),
    access: ["04.04.01.00"],
  },
  {
    key: "finance-neraca",
    path: `${APP_PREFIX_PATH}/finance/neraca`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/report/neraca"),
    ),
    access: ["04.04.02.00"],
  },
  {
    key: "finance-neraca-konsolidasi",
    path: `${APP_PREFIX_PATH}/finance/neraca-konsolidasi`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/report/neraca-konsolidasi"),
    ),
    access: ["04.04.05.00"],
  },
  {
    key: "finance-laba-rugi",
    path: `${APP_PREFIX_PATH}/finance/laba-rugi`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/report/laba-rugi"),
    ),
    access: ["04.04.03.00"],
  },
  {
    key: "finance-laba-rugi-konsolidasi",
    path: `${APP_PREFIX_PATH}/finance/laba-rugi-konsolidasi`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/report/laba-rugi-konsolidasi"),
    ),
    access: ["04.04.04.00"],
  },
  {
    key: "finance-tutup-buku-bulan",
    path: `${APP_PREFIX_PATH}/finance/tutup-buku/bulan`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/tutup-buku/tutup-bulan"),
    ),
    access: ["04.05.00.00"],
  },
  {
    key: "finance-tutup-buku-tahun",
    path: `${APP_PREFIX_PATH}/finance/tutup-buku/tahun`,
    component: React.lazy(
      () => import("views/app-views/finance-accounting/tutup-buku/tutup-tahun"),
    ),
    access: ["04.05.00.00"],
  },
  {
    key: "finance-tutup-buku-tahun-detail",
    path: `${APP_PREFIX_PATH}/finance/tutup-buku/tahun/detail`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/tutup-buku/tutup-tahun/detail"),
    ),
    access: ["04.05.00.00"],
  },
  {
    key: "finance-tutup-buku-tahun-form",
    path: `${APP_PREFIX_PATH}/finance/tutup-buku/tahun/form`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/tutup-buku/tutup-tahun/form"),
    ),
    access: [],
  },
  // Faktur Pajak Daftar Faktur
  {
    key: "daftar-faktur-pajak",
    path: `${APP_PREFIX_PATH}/faktur-pajak/daftar-faktur-pajak`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/faktur-pajak/daftar-faktur/data"),
    ),
    access: ["04.06.01.00"],
  },
  // Faktur Pajak Upload Faktur
  {
    key: "upload-faktur-pajak",
    path: `${APP_PREFIX_PATH}/faktur-pajak/upload-faktur-pajak`,
    component: React.lazy(
      () =>
        import("views/app-views/finance-accounting/faktur-pajak/upload-faktur"),
    ),
    access: ["04.06.02"],
  },

  // Job Order
  {
    key: "job-order-data",
    path: `${APP_PREFIX_PATH}/job-order`,
    component: React.lazy(() => import("views/app-views/job-order/data")),
    access: ["01.04.00"],
  },
  {
    key: "job-order-detail",
    path: `${APP_PREFIX_PATH}/job-order/detail`,
    component: React.lazy(() => import("views/app-views/job-order/detail")),
    access: [
      "01.04.04.00",
      "01.04.04.04.00",
      "01.04.04.05.00",
      "03.01.04.00",
      "03.01.04.04.00",
      "03.01.04.05.00",
    ],
  },
  {
    key: "job-order-form",
    path: `${APP_PREFIX_PATH}/job-order/form`,
    component: React.lazy(() => import("views/app-views/job-order/form")),
    access: ["01.04.01", "01.04.02", "03.01.01", "03.01.02"],
  },
  {
    key: "job-order-draft-billing-form",
    path: `${APP_PREFIX_PATH}/job-order/draft-billing/form`,
    component: React.lazy(
      () => import("views/app-views/job-order/draft-billing/cost/form"),
    ),
    access: [
      "01.04.04.05.02",
      "01.04.04.05.03",
      "03.01.04.05.02",
      "03.01.04.05.03",
    ],
  },
  {
    key: "job-order-print-rekap",
    path: `${APP_PREFIX_PATH}/job-order/rekap/print`,
    component: React.lazy(
      () => import("views/app-views/job-order/rekap/print"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["01.04.04.03", "03.01.04.03"],
  },
  {
    key: "job-order-preview-rekap",
    path: `${APP_PREFIX_PATH}/job-order/rekap/preview`,
    component: React.lazy(
      () => import("views/app-views/job-order/rekap/preview"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["01.04.04.06", "03.01.04.06"],
  },

  // Vendor
  {
    key: "vendor-data",
    path: `${APP_PREFIX_PATH}/procurement/vendor`,
    component: React.lazy(
      () => import("views/app-views/procurement/vendor/data"),
    ),
    access: ["02.00.00"],
  },
  {
    key: "vendor-form",
    path: `${APP_PREFIX_PATH}/procurement/vendor/form`,
    component: React.lazy(
      () => import("views/app-views/procurement/vendor/form"),
    ),
    access: ["02.00.01", "02.00.02"],
  },
  {
    key: "vendor-detail",
    path: `${APP_PREFIX_PATH}/procurement/vendor/detail`,
    component: React.lazy(
      () => import("views/app-views/procurement/vendor/detail"),
    ),
    access: ["02.00.04.00", "02.00.04.03.00"],
  },

  // Tarif Vendor
  {
    key: "tarif-vendor-form",
    path: `${APP_PREFIX_PATH}/procurement/vendor/pricelist/form`,
    component: React.lazy(
      () => import("views/app-views/procurement/vendor/detail/tarif/form"),
    ),
    access: ["02.00.04.03.01", "02.00.04.03.02"],
  },
  {
    key: "tarif-vendor-detail",
    path: `${APP_PREFIX_PATH}/procurement/vendor/pricelist/detail`,
    component: React.lazy(
      () => import("views/app-views/procurement/vendor/detail/tarif/detail"),
    ),
    access: ["02.00.04.03.04"],
  },
  // Margin Per Job
  {
    key: "margin-per-job",
    path: `${APP_PREFIX_PATH}/job-margin`,
    component: React.lazy(
      () => import("views/app-views/procurement/job-margin"),
    ),
    access: ["02.02.00"],
  },
  // Lifting Report
  {
    key: "lifting-report-voyage",
    path: `${APP_PREFIX_PATH}/management/lifting-report/voyage`,
    component: React.lazy(
      () => import("views/app-views/management/lifting-report/voyage"),
    ),
    access: ["05.04.00"],
  },
  {
    key: "lifting-report-customer",
    path: `${APP_PREFIX_PATH}/management/lifting-report/customer`,
    component: React.lazy(
      () => import("views/app-views/management/lifting-report/customer"),
    ),
    access: ["05.04.01"],
  },
  {
    key: "lifting-report-fcl-only",
    path: `${APP_PREFIX_PATH}/management/lifting-report/fcl-only`,
    component: React.lazy(
      () => import("views/app-views/management/lifting-report/fcl-only"),
    ),
    access: ["05.04.02"],
  },
  {
    key: "lifting-report-sub",
    path: `${APP_PREFIX_PATH}/management/lifting-report/sub`,
    component: React.lazy(
      () => import("views/app-views/management/lifting-report/sub"),
    ),
    access: ["05.04.03"],
  },
  {
    key: "lifting-report-own",
    path: `${APP_PREFIX_PATH}/management/lifting-report/own`,
    component: React.lazy(
      () => import("views/app-views/management/lifting-report/own"),
    ),
    access: ["05.04.04"],
  },
  {
    key: "lifting-report-inactive-customer",
    path: `${APP_PREFIX_PATH}/management/lifting-report/inactive-customer`,
    component: React.lazy(
      () =>
        import("views/app-views/management/lifting-report/inactive-customer"),
    ),
    access: ["05.04.05"],
  },
  {
    key: "lifting-report-top-revenue",
    path: `${APP_PREFIX_PATH}/management/lifting-report/top-revenue`,
    component: React.lazy(
      () => import("views/app-views/management/lifting-report/top-revenue"),
    ),
    access: ["05.04.06"],
  },
  {
    key: "lifting-report-top-job-order",
    path: `${APP_PREFIX_PATH}/management/lifting-report/top-job-order`,
    component: React.lazy(
      () => import("views/app-views/management/lifting-report/top-job-order"),
    ),
    access: ["05.04.07"],
  },
  {
    key: "lifting-report-top-gross-margin",
    path: `${APP_PREFIX_PATH}/management/lifting-report/top-gross-margin`,
    component: React.lazy(
      () =>
        import("views/app-views/management/lifting-report/top-gross-margin"),
    ),
    access: ["05.04.08"],
  },
  // Delivery Order
  {
    key: "delivery-data",
    path: `${APP_PREFIX_PATH}/operational/delivery-order`,
    component: React.lazy(
      () => import("views/app-views/operational/delivery/data"),
    ),
    access: ["03.00.00"],
  },
  {
    key: "delivery-form",
    path: `${APP_PREFIX_PATH}/operational/delivery-order/form`,
    component: React.lazy(
      () => import("views/app-views/operational/delivery/form"),
    ),
    access: ["03.00.01", "03.00.02"],
  },
  {
    key: "delivery-detail",
    path: `${APP_PREFIX_PATH}/operational/delivery-order/detail`,
    component: React.lazy(
      () => import("views/app-views/operational/delivery/detail"),
    ),
    access: ["03.00.04.00"],
  },
  {
    key: "delivery-print",
    path: `${APP_PREFIX_PATH}/operational/delivery-order/print/bstb`,
    component: React.lazy(
      () => import("views/app-views/operational/delivery/print/bstb"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["03.00.04.09"],
  },
  {
    key: "delivery-preview",
    path: `${APP_PREFIX_PATH}/operational/delivery-order/print/preview`,
    component: React.lazy(
      () => import("views/app-views/operational/delivery/print/preview"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["03.00.04.10"],
  },
  // Upload BASJ
  {
    key: "upload-bstb",
    path: `${APP_PREFIX_PATH}/operational/upload-bstb`,
    component: React.lazy(
      () => import("views/app-views/operational/upload-bstb"),
    ),
    access: ["03.04.04"],
  },
  {
    key: "upload-basj-pengirim",
    path: `${APP_PREFIX_PATH}/operational/upload-basj-pengirim`,
    component: React.lazy(
      () => import("views/app-views/operational/upload-basj"),
    ),
    access: ["03.04.01"],
  },
  {
    key: "upload-bstb-continue",
    path: `${APP_PREFIX_PATH}/operational/upload-bstb-continue`,
    component: React.lazy(
      () => import("views/app-views/operational/upload-bstb-continue"),
    ),
    access: ["03.04.03"],
  },
  {
    key: "upload-bstb-delivered",
    path: `${APP_PREFIX_PATH}/operational/upload-bstb-delivered`,
    component: React.lazy(
      () => import("views/app-views/operational/upload-bstb-delivered"),
    ),
    access: ["03.04.02"],
  },

  // Laporan Resi/BA Kembali
  {
    key: "voyage-information",
    path: `${APP_PREFIX_PATH}/operational/information`,
    component: React.lazy(
      () => import("views/app-views/operational/information/data"),
    ),
    access: [],
  },

  // Voyage
  {
    key: "voyage-data",
    path: `${APP_PREFIX_PATH}/operational/voyage`,
    component: React.lazy(
      () => import("views/app-views/operational/voyage/data"),
    ),
    access: ["03.03.00"],
  },
  {
    key: "voyage-form",
    path: `${APP_PREFIX_PATH}/operational/voyage/form`,
    component: React.lazy(
      () => import("views/app-views/operational/voyage/form"),
    ),
    access: ["03.03.01", "03.03.02"],
  },
  {
    key: "voyage-detail",
    path: `${APP_PREFIX_PATH}/operational/voyage/detail`,
    component: React.lazy(
      () => import("views/app-views/operational/voyage/detail"),
    ),
    access: ["03.03.04.00", "03.03.04.04.00"],
  },
  {
    key: "voyage-print",
    path: `${APP_PREFIX_PATH}/operational/voyage/print/bstb`,
    component: React.lazy(
      () => import("views/app-views/operational/voyage/print/bstb"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["03.03.04.04.02"],
  },
  // Kontainer
  {
    key: "packing-list",
    path: `${APP_PREFIX_PATH}/operational/packing-list`,
    component: React.lazy(
      () => import("views/app-views/operational/packing-list/data"),
    ),
    access: ["03.02.00"],
  },
  {
    key: "packing-list-detail",
    path: `${APP_PREFIX_PATH}/operational/packing-list/detail`,
    component: React.lazy(
      () => import("views/app-views/operational/packing-list/detail"),
    ),
    access: ["03.02.04.00", "03.02.05.00", "03.02.06.00", "03.02.07.00"],
  },
  {
    key: "packing-list-form",
    path: `${APP_PREFIX_PATH}/operational/packing-list/form`,
    component: React.lazy(
      () => import("views/app-views/operational/packing-list/form"),
    ),
    access: ["03.02.01", "03.02.02"],
  },
  {
    key: "packing-list-print",
    path: `${APP_PREFIX_PATH}/operational/packing-list/print`,
    component: React.lazy(
      () => import("views/app-views/operational/packing-list/print"),
    ),
    meta: {
      blankLayout: true,
    },
    access: ["03.02.05.02"],
  },
  {
    key: "packing-list-draft-billing-form",
    path: `${APP_PREFIX_PATH}/operational/packing-list/draft-billing/form`,
    component: React.lazy(
      () =>
        import("views/app-views/operational/packing-list/draft-billing/cost/form"),
    ),
    access: ["03.02.07.02", "03.02.07.03"],
  },
  // Pengaturan Umum
  {
    key: "general-settings",
    path: `${APP_PREFIX_PATH}/general-setting`,
    component: React.lazy(() => import("views/app-views/general-setting")),
    access: ["00.12.00", "00.12.01"],
  },

  // Cabang Operasional
  {
    key: "branch-data",
    path: `${APP_PREFIX_PATH}/master-data/cabang-operasional`,
    component: React.lazy(
      () => import("views/app-views/master-data/operational-branch/data"),
    ),
    access: ["00.00.00"],
  },
  {
    key: "branch-detail",
    path: `${APP_PREFIX_PATH}/master-data/cabang-operasional/detail`,
    component: React.lazy(
      () => import("views/app-views/master-data/operational-branch/detail"),
    ),
    access: ["00.00.04.00", "00.00.04.01.00"],
  },
  {
    key: "branch-form",
    path: `${APP_PREFIX_PATH}/master-data/cabang-operasional/form`,
    component: React.lazy(
      () => import("views/app-views/master-data/operational-branch/form"),
    ),
    access: ["00.00.01", "00.00.02"],
  },
  // Penomoran Cabang
  {
    key: "branch-numbering",
    path: `${APP_PREFIX_PATH}/master-data/cabang-operasional/penomoran`,
    component: React.lazy(
      () =>
        import("views/app-views/master-data/operational-branch/numbering/data"),
    ),
    access: ["00.00.04.01.00"],
  },
  {
    key: "branch-numbering-form",
    path: `${APP_PREFIX_PATH}/master-data/cabang-operasional/penomoran/form`,
    component: React.lazy(
      () =>
        import("views/app-views/master-data/operational-branch/numbering/form"),
    ),
    access: ["00.00.04.01.01", "00.00.04.01.02"],
  },

  // Data Wilayah
  {
    key: "region-data",
    path: `${APP_PREFIX_PATH}/master-data/data-wilayah`,
    component: React.lazy(
      () => import("views/app-views/master-data/region/data"),
    ),
    access: ["00.04.00"],
  },
  {
    key: "region-form",
    path: `${APP_PREFIX_PATH}/master-data/data-wilayah/form`,
    component: React.lazy(
      () => import("views/app-views/master-data/region/form"),
    ),
    access: ["00.04.01", "00.04.02"],
  },

  // Kondisi Lain
  {
    key: "other-condition-data",
    path: `${APP_PREFIX_PATH}/master-data/kondisi-lain`,
    component: React.lazy(
      () => import("views/app-views/master-data/other-condition/data"),
    ),
    access: [],
  },
  {
    key: "other-condition-detail",
    path: `${APP_PREFIX_PATH}/master-data/kondisi-lain/detail`,
    component: React.lazy(
      () => import("views/app-views/master-data/other-condition/detail"),
    ),
    access: ["00.05.00"],
  },
  {
    key: "other-condition-form",
    path: `${APP_PREFIX_PATH}/master-data/kondisi-lain/form`,
    component: React.lazy(
      () => import("views/app-views/master-data/other-condition/form"),
    ),
    access: ["00.05.01", "00.05.02"],
  },
  // Daftar Biaya
  {
    key: "daftar-biaya-data",
    path: `${APP_PREFIX_PATH}/master-data/daftar-biaya`,
    component: React.lazy(
      () =>
        import("views/app-views/master-data/master-biaya/daftar-biaya/data"),
    ),
    access: ["00.07.00"],
  },
  {
    key: "daftar-biaya-form",
    path: `${APP_PREFIX_PATH}/master-data/daftar-biaya/form`,
    component: React.lazy(
      () =>
        import("views/app-views/master-data/master-biaya/daftar-biaya/form"),
    ),
    access: ["00.07.01", "00.07.02"],
  },
  // Daftar Biaya
  {
    key: "template-biaya-data",
    path: `${APP_PREFIX_PATH}/master-data/template-biaya`,
    component: React.lazy(
      () =>
        import("views/app-views/master-data/master-biaya/template-biaya/data"),
    ),
    access: ["00.08.00"],
  },
  {
    key: "template-biaya-form",
    path: `${APP_PREFIX_PATH}/master-data/template-biaya/form`,
    component: React.lazy(
      () =>
        import("views/app-views/master-data/master-biaya/template-biaya/form"),
    ),
    access: ["00.08.01", "00.08.02"],
  },
  {
    key: "template-biaya-detail",
    path: `${APP_PREFIX_PATH}/master-data/template-biaya/detail`,
    component: React.lazy(
      () =>
        import("views/app-views/master-data/master-biaya/template-biaya/detail"),
    ),
    access: ["00.08.04.00"],
  },
  {
    key: "component-biaya-form",
    path: `${APP_PREFIX_PATH}/master-data/template-biaya/komponen-biaya/form`,
    component: React.lazy(
      () =>
        import("views/app-views/master-data/master-biaya/template-biaya/component-biaya/form"),
    ),
    access: ["00.08.04.01", "00.08.04.02"],
  },
  // Product
  {
    key: "product-data",
    path: `${APP_PREFIX_PATH}/master-data/produk-jasa`,
    component: React.lazy(
      () => import("views/app-views/master-data/product/data"),
    ),
    access: ["00.03.00"],
  },
  {
    key: "product-form",
    path: `${APP_PREFIX_PATH}/master-data/produk-jasa/form`,
    component: React.lazy(
      () => import("views/app-views/master-data/product/form"),
    ),
    access: ["00.03.01", "00.03.02"],
  },

  // Account
  {
    key: "account-data",
    path: `${APP_PREFIX_PATH}/master-data/account`,
    component: React.lazy(
      () => import("views/app-views/master-data/account/data"),
    ),
    access: ["00.06.00"],
  },
  {
    key: "account-form",
    path: `${APP_PREFIX_PATH}/master-data/account/form`,
    component: React.lazy(
      () => import("views/app-views/master-data/account/form"),
    ),
    access: ["00.06.01", "00.06.02"],
  },

  // Commodity
  {
    key: "commodity-data",
    path: `${APP_PREFIX_PATH}/master-data/commodity`,
    component: React.lazy(
      () => import("views/app-views/master-data/commodity/data"),
    ),
    access: ["00.09.00"],
  },
  {
    key: "commodity-form",
    path: `${APP_PREFIX_PATH}/master-data/commodity/form`,
    component: React.lazy(
      () => import("views/app-views/master-data/commodity/form"),
    ),
    access: ["00.09.01", "00.09.02"],
  },
  // Vehicle
  {
    key: "vehicle-data",
    path: `${APP_PREFIX_PATH}/master-data/vehicle`,
    component: React.lazy(
      () => import("views/app-views/master-data/vehicle/data"),
    ),
    access: ["00.10.00"],
  },
  {
    key: "vehicle-form",
    path: `${APP_PREFIX_PATH}/master-data/vehicle/form`,
    component: React.lazy(
      () => import("views/app-views/master-data/vehicle/form"),
    ),
    access: ["00.10.01", "00.10.02"],
  },

  // Unit/Satuan
  {
    key: "unit-data",
    path: `${APP_PREFIX_PATH}/master-data/unit`,
    component: React.lazy(
      () => import("views/app-views/master-data/unit/data"),
    ),
    access: ["00.11.00"],
  },
  {
    key: "unit-form",
    path: `${APP_PREFIX_PATH}/master-data/unit/form`,
    component: React.lazy(
      () => import("views/app-views/master-data/unit/form"),
    ),
    access: ["00.11.01", "00.11.02"],
  },

  // User Data
  {
    key: "user-data",
    path: `${APP_PREFIX_PATH}/manajemen-pengguna`,
    component: React.lazy(() => import("views/app-views/user-management/data")),
    access: ["00.01.00"],
  },
  {
    key: "user-detail",
    path: `${APP_PREFIX_PATH}/manajemen-pengguna/detail`,
    component: React.lazy(
      () => import("views/app-views/user-management/detail"),
    ),
    access: ["00.01.04.00"],
  },
  {
    key: "user-form",
    path: `${APP_PREFIX_PATH}/manajemen-pengguna/form`,
    component: React.lazy(() => import("views/app-views/user-management/form")),
    access: ["00.01.01", "00.01.02"],
  },
  // Role & Permission
  {
    key: "role-data",
    path: `${APP_PREFIX_PATH}/role-permission`,
    component: React.lazy(() => import("views/app-views/role-permission/data")),
    access: ["00.02.00"],
  },
  {
    key: "role-form",
    path: `${APP_PREFIX_PATH}/role-permission/form`,
    component: React.lazy(() => import("views/app-views/role-permission/form")),
    access: ["00.02.01", "00.02.02"],
  },

  // KPI
  {
    key: "management-kpi-data-entry",
    path: `${APP_PREFIX_PATH}/management/kpi/data-entry`,
    component: React.lazy(
      () => import("views/app-views/management/kpi/data-entry"),
    ),
    access: [
      "05.01.00.00",
      "05.01.00.01",
      "05.01.00.02",
      "05.01.00.03",
      "05.01.00.04",
      "05.01.00.05",
    ],
  },
  {
    key: "management-kpi-customer-service",
    path: `${APP_PREFIX_PATH}/management/kpi/customer-service`,
    component: React.lazy(
      () => import("views/app-views/management/kpi/customer-service"),
    ),
    access: ["05.01.01.00", "05.01.01.01", "05.01.01.02"],
  },
  {
    key: "management-kpi-procurement",
    path: `${APP_PREFIX_PATH}/management/kpi/procurement`,
    component: React.lazy(
      () => import("views/app-views/management/kpi/procurement"),
    ),
    access: ["05.01.02"],
  },
  {
    key: "management-kpi-account-receivable",
    path: `${APP_PREFIX_PATH}/management/kpi/account-receivable`,
    component: React.lazy(
      () => import("views/app-views/management/kpi/account-receivable"),
    ),
    access: ["05.01.03.00", "05.01.03.01"],
  },
  {
    key: "management-kpi-tax",
    path: `${APP_PREFIX_PATH}/management/kpi/tax`,
    component: React.lazy(() => import("views/app-views/management/kpi/tax")),
    access: ["05.01.04"],
  },

  // Management
  {
    key: "management-legal",
    path: `${APP_PREFIX_PATH}/management/legal`,
    component: React.lazy(() => import("views/app-views/management/legal")),
    access: ["05.00.00"],
  },
  {
    key: "management-legal-form",
    path: `${APP_PREFIX_PATH}/management/legal/form`,
    component: React.lazy(
      () => import("views/app-views/management/legal/form"),
    ),
    access: ["05.00.01", "05.00.02"],
  },
  {
    key: "management-customer-rating",
    path: `${APP_PREFIX_PATH}/management/customer-rating`,
    component: React.lazy(
      () => import("views/app-views/management/customer-rating"),
    ),
    access: [],
  },
  {
    key: "management-customer-rating-detail",
    path: `${APP_PREFIX_PATH}/management/customer-rating/detail`,
    component: React.lazy(
      () => import("views/app-views/management/customer-rating/detail"),
    ),
    access: ["05.02.00"],
  },

  // Profile
  {
    key: "my-profile",
    path: `${APP_PREFIX_PATH}/profile`,
    component: React.lazy(() => import("views/app-views/profile")),
    access: [],
  },
  {
    key: "notification",
    path: `${APP_PREFIX_PATH}/notification`,
    component: React.lazy(() => import("views/app-views/notification")),
    access: ["06.01"],
  },
  {
    key: "scan-qrcode",
    path: `${APP_PREFIX_PATH}/scan`,
    component: React.lazy(() => import("views/app-views/scan-qr")),
    meta: {
      blankLayout: true,
    },
    access: ["06.00.00", "06.00.01"],
  },
  {
    key: "scan-qrcode",
    path: `${APP_PREFIX_PATH}/camera-test`,
    component: React.lazy(() => import("views/app-views/scan-qr/camera-test")),
    meta: {
      blankLayout: true,
    },
    access: ["06.00.00", "06.00.01"],
  },
  // Developer
  {
    key: "changelog",
    path: `${APP_PREFIX_PATH}/changelog`,
    component: React.lazy(() => import("views/app-views/dev/changelog/user")),
    access: ["05.00.00"],
  },
  {
    key: "dev-changelog",
    path: `${APP_PREFIX_PATH}/dev/changelog`,
    component: React.lazy(() => import("views/app-views/dev/changelog")),
    access: ["05.00.00"],
  },
  {
    key: "dev-changelog",
    path: `${APP_PREFIX_PATH}/dev/changelog/form`,
    component: React.lazy(() => import("views/app-views/dev/changelog/form")),
    access: ["05.00.01", "05.00.02"],
  },
  // Other
  {
    key: "403",
    path: `/access-denied`,
    component: React.lazy(() => import("views/auth-views/errors/403")),
    meta: {
      blankLayout: true,
    },
    access: [],
  },
  {
    key: "error",
    path: `*`,
    component: React.lazy(() => import("views/auth-views/errors/404")),
    meta: {
      blankLayout: true,
    },
    access: [],
  },
];
